import { ReactJSXElement } from "@emotion/react/types/jsx-namespace";
import { createElement } from "react";
import UnknownActionForm from "components/actions/unknown/unknown-action-form";
import UnknownActionResult from "components/actions/unknown/unknown-action-result";
import RemoveOrphanedUsersActionForm from "components/actions/orphaned-users/remove-orphaned-users-action/remove-orphaned-users-action-form"
import RemoveOrphanedUsersActionResult from "components/actions/orphaned-users/remove-orphaned-users-action/remove-orphaned-users-action-result";
import RemoveGuestUsersActionForm from "components/actions/guest-users/remove-guest-users-action/remove-guest-users-action-form";
import RemoveGuestUsersActionResult from "components/actions/guest-users/remove-guest-users-action/remove-guest-users-action-result";
import RemoveSharingLinksActionForm from "components/actions/sharing-links/remove-sharing-links-action/remove-sharing-links-action-form";
import RemoveSharingLinksActionResult from "components/actions/sharing-links/remove-sharing-links-action/remove-sharing-links-action-result";
import { ILocaleStrings } from "loc/locale.interfaces";


export const getActionFormComponent = (actionType: number): ReactJSXElement => {
    switch (actionType) {
        case 1:
            return createElement(RemoveOrphanedUsersActionForm);
        case 2:
            return createElement(RemoveGuestUsersActionForm);
        case 3:
            return createElement(RemoveSharingLinksActionForm);
        default:
            return createElement(UnknownActionForm);
    }
}

export const getActionResultComponent = (actionType: number): ReactJSXElement => {
    switch (actionType) {
        case 1:
            return createElement(RemoveOrphanedUsersActionResult);
        case 2:
            return createElement(RemoveGuestUsersActionResult);
        case 3:
            return createElement(RemoveSharingLinksActionResult);
        default:
            return createElement(UnknownActionResult);
    }
}

// public enum ActionType
// {
//     None = 0,
//     RemoveOrphanedUsers = 1,
//     RemoveGuestUsers = 2,
//     RemoveSharingLinks = 3
// }

export const getActionTypeKey = (actionType: number): keyof ILocaleStrings => {
    switch (actionType) {
        case 1:
            return "ppaRemoveOrphanedUsersActionTitle";
        case 2:
            return "ppaRemoveGuestUsersActionTitle";
        case 3:
            return "ppaRemoveSharingLinksActionTitle";
        default:
            return "unknown";
    }
};